export default __webpack_public_path__ + "static/media/light_off.45727b04.svg";